type Props = {
  className?: string;
};

export default function LongRightArrow({ className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="15"
      viewBox="0 0 60 15"
      fill="none"
      className={className}
    >
      <path
        d="M59.7071 8.07088C60.0976 7.68035 60.0976 7.04719 59.7071 6.65666L53.3431 0.292702C52.9526 -0.0978227 52.3195 -0.0978227 51.9289 0.292702C51.5384 0.683226 51.5384 1.31639 51.9289 1.70692L57.5858 7.36377L51.9289 13.0206C51.5384 13.4111 51.5384 14.0443 51.9289 14.4348C52.3195 14.8254 52.9526 14.8254 53.3431 14.4348L59.7071 8.07088ZM0 7.36377V8.36377H59V7.36377V6.36377H0V7.36377Z"
        fill="#5B5B5B"
      />
    </svg>
  );
}
